// Based on the definitions at 'ycharts/settings/ycharts.py'
export const ALTERNATIVE_REGEX = /\bA:[A-Z0-9]+\b/;
export const BOND_CUSIP_REGEX = /\b[0-9A-Z]{9}\b/;
export const CUSTOM_SECURITY_SECURITY_ID_REGEX = /\bY:[0-9]+\b/;
export const EXCHANGE_SYMBOL_REGEX = /\b[A-Z0-9]+(?:\.[A-Z0-9]+)*(?:\^[A-Z0-9]+)*(:DL)*/; // Company
export const INDEX_SYMBOL_REGEX = /\^[A-Z0-9]+\b/; // '^' is already a word boundary
export const INDICATOR_CODE_REGEX = /\bI:[A-Z0-9]{1,10}\b/;
export const MODEL_PORTFOLIO_SECURITY_ID_REGEX = /\bP:[0-9]+\b/;
// M:          - Literal "M:" prefix
// [A-Z0-9-]+  - Main symbol (VTSAX or Y-ABC123)
// (\.[...]+)* - Optional exchange (.TO) or optional share class (.S-PR)
// (\^[...]+)* - Optional segment for some delisted Lipper funds missing tickers (^E24)
// (:DL)*      - Optional delisted suffix
export const MUTUAL_FUND_EXCHANGE_SYMBOL_REGEX = /\bM:[A-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*(?:\^[A-Z0-9]+)*(:DL)*\b/;
export const NUMERIC_ID_REGEX = /\b[0-9]+\b/;
export const SEPARATE_ACCOUNT_EXCHANGE_SYMBOL_REGEX = /\bS:[A-Z0-9]+(:DL)*\b/;
export const WATCH_LIST_NAME_REGEX = /\bwatchlist-\d+\b/;
export const QUOTEABLE_SYMBOL_REGEX = /\b[A-Z0-9^:]+(?:\.[A-Z0-9-]+)*\b/;

export const SECURITY_IDS = {
    ALTERNATIVE_REGEX,
    BOND_CUSIP_REGEX,
    CUSTOM_SECURITY_SECURITY_ID_REGEX,
    EXCHANGE_SYMBOL_REGEX,
    INDEX_SYMBOL_REGEX,
    INDICATOR_CODE_REGEX,
    MODEL_PORTFOLIO_SECURITY_ID_REGEX,
    MUTUAL_FUND_EXCHANGE_SYMBOL_REGEX,
    NUMERIC_ID_REGEX,
    SEPARATE_ACCOUNT_EXCHANGE_SYMBOL_REGEX,
    WATCH_LIST_NAME_REGEX,
    QUOTEABLE_SYMBOL_REGEX,
};

export const SECURITY_ID_REGEX_SOURCE = Object.values(SECURITY_IDS)
    .map((regex) => regex.source)
    .join('|');
